import { useAuth } from "context/auth";
import React, { useEffect, useState } from "react";
import queryString from "query-string";

// reactstrap components
import { Card, CardBody, Row, Col, Container } from "reactstrap";
import ProgressBar from "../../../components/ProgressBar/StepperProgress";

//Services
import { api_GET } from "../../../services/api_service";
import { showMessage } from "../../../services/message";

//Components
import DadosObra from "../../../views/Shared/GeradorPGRCC/DadosObra";
import DestinoPGRCC from "../../../views/Shared/GeradorPGRCC/DestinoPGRCC";
import Declaracao from "../../../views/Shared/Declaracao";
import Documentos from "../../../views/Shared/Documentos";
import ExecutorObra from "../../../views/Shared/GeradorPGRCC/ExecutorObra";
import Identificacao from "../../../views/Shared/Gerador/Identificacao";
import GeradorObra from "../../../views/Shared/GeradorPGRCC/GeradorObra";
import PlanoResiduoDetalhamento from "../../../views/Shared/GeradorPGRCC/PlanoResiduoDetalhamento";
import PlanoResiduoModelo from "../../../views/Shared/GeradorPGRCC/PlanoResiduoModelo";
import InformacoesComplementares from "../../../views/Shared/GeradorPGRCC/InformacoesComplementares";
import TransportadoresPGRCC from "../../../views/Shared/GeradorPGRCC/TransportadoresPGRCC";
import RequerimentoAvisoCard from '../components/RequerimentoAvisoCard';

export default function GeradorPGRCCRequerimentoNovoCadastro({ history }) {
  const { session, setupSistema } = useAuth();

  const [requerimento, setRequerimento] = useState(null);

  const steps = [
    "Gestor do PGRCC",
    "Gerador da Obra",
    "Executor da Obra",
    "Dados da Obra",
    "Plano de Resíduos - Modelo",
    "Plano de Resíduos - Detalhamento",
    "Transportadores",
    "Destinos",
    "Informações Complementares",
    "Documentos",
  ];

  const [step, set_step] = useState(0);

  const [opcao, set_opcao] = useState({});

  const handleProximoStep = (_requerimento) => {
    if (step === 11) {
      history.push("opcoes");
    } else {
      setRequerimento(_requerimento);
      set_step((prevState) => prevState + 1);
    }
  };
  const handleStepAnterior = (_requerimento) => {
    setRequerimento(_requerimento);
    if (set_step < 0) set_step(0);
    else set_step((prevState) => prevState - 1);
  };

  async function loadRequerimento() {
    try {
      const urls = history.location.search;
      const params = queryString.parse(urls);

      if (params && params.protocolo) {
        const { data } = await api_GET(
          "requerimento/ByNumeroProtocolo/" + params.protocolo
        );

        set_opcao({
          tipoCadastro: "Requerimento",
          segmento: "Grande Gerador - PGRCC",
          categoria: data.setupSolicitacaoAcao.setupSolicitacao.categoria,
        });

        setRequerimento(data);

        if (data.status === "Divergente") {
          set_step(0);
        } else if (data.etapaCadastro != null) {
          set_step(data.etapaCadastro);
        }
      }
    } catch (err) {
      showMessage("Aviso", err.message, "error", null);
    }
  }

  useEffect(() => {
    loadRequerimento();
  }, []);

  return (
    <>
      {requerimento != null && step < 11 && (
        <div className="content">
          <Container className="text-center">
            <ProgressBar stepValue={step} steps={steps} />
          </Container>
          {requerimento.status === "Divergente" &&
            requerimento.requerimentoAnaliseGestor.length > 0 && (
              <Card className="card-stats">
                <CardBody>
                  <h5 className="text-danger">
                    Seu requerimento foi rejeitado por{" "}
                    {setupSistema?.identificacao}. Verifique as informações
                    abaixo e corrija os dados necessários.
                  </h5>
                  <p>
                    {
                      requerimento.requerimentoAnaliseGestor.sort(function (
                        a,
                        b
                      ) {
                        return (
                          new Date(b.dataAnalise) - new Date(a.dataAnalise)
                        );
                      })[0].observacao
                    }
                  </p>
                </CardBody>
              </Card>
            )}

          {step === 0 && (
            <>
              <RequerimentoAvisoCard />
              <Identificacao
                item={requerimento}
                opcao={opcao}
                handleProximoStep={handleProximoStep}
              />
            </>
          )}

          {step === 1 && (
            <GeradorObra
              item={requerimento}
              setItem={setRequerimento}
              opcao={opcao}
              handleProximoStep={handleProximoStep}
              handleStepAnterior={handleStepAnterior}
            />
          )}

          {step === 2 && (
            <ExecutorObra
              item={requerimento}
              setItem={setRequerimento}
              opcao={opcao}
              handleProximoStep={handleProximoStep}
              handleStepAnterior={handleStepAnterior}
            />
          )}

          {step === 3 && (
            <DadosObra
              item={requerimento}
              setItem={setRequerimento}
              opcao={opcao}
              handleProximoStep={handleProximoStep}
              handleStepAnterior={handleStepAnterior}
            />
          )}

          {step === 4 && (
            <PlanoResiduoModelo
              item={requerimento}
              setItem={setRequerimento}
              opcao={opcao}
              handleProximoStep={handleProximoStep}
              handleStepAnterior={handleStepAnterior}
            />
          )}

          {step === 5 && (
            <PlanoResiduoDetalhamento
              item={requerimento}
              setItem={setRequerimento}
              opcao={opcao}
              handleProximoStep={handleProximoStep}
              handleStepAnterior={handleStepAnterior}
            />
          )}

          {step === 6 && (
            <TransportadoresPGRCC
              item={requerimento}
              setItem={setRequerimento}
              opcao={opcao}
              handleProximoStep={handleProximoStep}
              handleStepAnterior={handleStepAnterior}
            />
          )}

          {step === 7 && (
            <DestinoPGRCC
              item={requerimento}
              setItem={setRequerimento}
              opcao={opcao}
              handleProximoStep={handleProximoStep}
              handleStepAnterior={handleStepAnterior}
            />
          )}

          {step === 8 && (
            <InformacoesComplementares
              item={requerimento}
              setItem={setRequerimento}
              opcao={opcao}
              handleProximoStep={handleProximoStep}
              handleStepAnterior={handleStepAnterior}
            />
          )}

          {step === 9 && (
            <Documentos
              item={requerimento}
              opcao={opcao}
              handleProximoStep={handleProximoStep}
              handleStepAnterior={handleStepAnterior}
            />
          )}

          {step === 10 && (
            <Declaracao
              item={requerimento}
              handleFinalizarCadastro={handleProximoStep}
              handleStepAnterior={handleStepAnterior}
            />
          )}
        </div>
      )}

      {requerimento != null && step === 11 && (
        <Container style={{ maxWidth: "1000px", margin: "20px auto" }}>
          <div className="formPrincipal">
            <Row
              style={{
                borderBottom: "1px solid rgba(0, 0, 0, .5)",
                paddingBottom: "10px",
                paddingTop: "10px",
              }}
            >
              <Col md="12">
                <span
                  className={`${
                    session && session.tipoAcesso === "AreaRestrita"
                      ? "text-white"
                      : "text-black"
                  }`}
                >
                  Este requerimento já foi finalizado. Para visualizar e
                  acompanhar as informações do requerimento, acesse o menu "Meu
                  Cadastro".
                </span>
              </Col>
            </Row>
          </div>
        </Container>
      )}
    </>
  );
}
